<div class="tw-h-full tw-w-full tw-overflow-hidden">
  <div class="tw-flex tw-flex-col tw-h-full">
    <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
             *ngIf="(!regimen?.class || loading) && !loadingByChild && !shouldShowAddOnInstructionUI()"></loading>
    <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-fixed tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-z-10"
         *ngIf="loadingByChild"
         style="background: rgba(0, 0, 0, 0.5);">
      <loading></loading>
    </div>
    <div class="tw-flex-1 tw-relative tw-overflow-x-hidden"
    [ngClass]="showRegimenEmptySection ? 'tw-overflow-y-hidden' : 'tw-overflow-y-auto'"
         #regimenModuleContainer="">
      <div *ngIf="regimen.regimenPreparation"
           class="tw-fixed tw-top-6 tw-left-4 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10 tw-z-20"
           (click)="back()"
           [class.tw-absolute]="regimen && regimen.showProductSummary && regimenModuleContainer && regimen">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
                 [iconName]="'arrow_back'"></cs-icon>
      </div>
      @if (!loading) {
        <ng-container *ngIf="consultationSession; then languageChangeHeader else defaultHeader"></ng-container>
      }
      <ng-template #defaultHeader>
        <!-- default header -->
        <div *ngIf="!regimen.regimenPreparation"
             class="tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-relative tw-z-[100]"
             [class]="{'tw-bg-gray-800': acqRebranding2025, 'tw-bg-black': !acqRebranding2025, 'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}">
          <div class="tw-fixed tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-10 tw-w-10 tw-z-20"
               (click)="back()"
               [ngClass]='{"tw-absolute": regimen && regimen.showProductSummary && regimenModuleContainer && regimen}'>
            <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
                     [iconName]="'arrow_back'"></cs-icon>
          </div>
          <div class="tw-flex-1 tw-flex  tw-items-center"
               [ngClass]="shouldShowLanguageDropDown ? 'tw-justify-start ' : 'tw-justify-center'">
            <span class="tw-font-bold tw-text-300 tw-text-white"
                  [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}"
                  i18n="@@getYourTreatment"
                  *ngIf="shouldShowGetYourTreatmentHeader">Get your treatment kit</span>
            <span class="tw-font-bold tw-text-300 tw-text-white"
                  [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025, 'tw-translate-x-[48px]': instructionsLanguageChangeExp, 'tw-translate-x-0': !instructionsLanguageChangeExp}"
                  i18n="@@instructions"
                  *ngIf="shouldShowInstructionsHeader">Instructions</span>
          </div>

          <div *ngIf="shouldShowLanguageDropDown"
               class="tw-flex tw-justify-end tw-items-center tw-w-max">
            <ng-container *ngTemplateOutlet="languageDropdown"></ng-container>
          </div>
        </div>
      </ng-template>
      <ng-template #languageChangeHeader>
        <!-- language change header -->
        <div *ngIf="!regimen.regimenPreparation"
             class="tw-sticky tw-top-0 tw-flex tw-justify-between tw-items-center tw-h-14 tw-pl-2 tw-pr-4 tw-z-[100]"
             [ngClass]="{'tw-bg-gray-800': acqRebranding2025, 'tw-bg-black': !acqRebranding2025}">
          <div class="tw-flex tw-items-center">
            <div class="tw-flex tw-justify-center tw-items-center tw-p-2">
              <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
                       [iconName]="'arrow_back'"
                       (click)="back()"></cs-icon>
            </div>
            <span *ngIf="regimen.class === 'FACE'"
                  class="tw-font-body tw-font-normal tw-text-gray-50"
                  [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}"
                  i18n="@@discoverClearSkin">Discover clear skin</span>
            <span *ngIf="regimen.class === 'HAIR'"
                  class="tw-font-body tw-font-normal tw-text-gray-50"
                  [ngClass]="{'tw-text-100': user?.get('languagePreference') === 'ta', 'tw-text-300': user?.get('languagePreference') !== 'ta'}"
                  i18n="@@discoverHealthyHair">Discover healthy hair</span>
          </div>
          <div class="tw-flex tw-items-center">
            <ng-container *ngTemplateOutlet="languageDropdown"></ng-container>
          </div>
        </div>
      </ng-template>
      @if (!loading){
        <toolbar-tabs class="tw-sticky tw-top-0 tw-z-10 tw-w-full"
                    [ngClass]="shouldShowRegimenPreparationUI ? 'tw-hidden' : 'tw-block'"
                    #toolbarTabs=""
                    (tabSelected)="tabChange($event)"
                    [data]="tabData"
                    [hidden]="redirectAfterRegimenPreparation"
                    [shouldFormatTabData]="true"
                    [acqRebranding2025]="acqRebranding2025">
          <tab1 class="tw-uppercase"><span i18n="@@face">Face</span></tab1>
          <tab2 class="tw-uppercase"><span i18n="@@hair">Hair</span></tab2>
          <!-- Tab 3: Show Body if hasBodyRegimen, otherwise show Add-ons if showAddOnInstruction -->
          @if (hasBodyRegimen && shouldShowAddOnInstructionTab()) {
          <ng-container>
            <tab3 class="tw-uppercase"><span>Body</span></tab3>
            <tab4 class="tw-uppercase"><span i18n="@@others">Others</span></tab4>
          </ng-container>
          } @else if (!hasBodyRegimen && shouldShowAddOnInstructionTab()) {
          <tab3 class="tw-uppercase"><span i18n="@@others">Others</span></tab3>
          }
        </toolbar-tabs>
      }
      @if (tabSwitching) {
        <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
      }
      <!--chat progress bar-->
      @if (shouldShowChatProgressBar) {
        <div id="chatProgressBar"
             #chatProgressBar
             class="tw-bg-yellow-100 tw-sticky tw-top-14 tw-w-full tw-left-0 tw-z-20">
          <div class="tw-h-2 tw-bg-yellow-500 tw-transition-all tw-duration-500 tw-ease-in-out"
               [style]="{ 'width': chatProgressValue + '%' }"></div>
        </div>
      }
      @if (shouldShowAddOnInstructionUI() && !loading) {
      <user-view-instructions [addOnInstructions]="addOnInstructions()"></user-view-instructions>
      }
      @if (showRegimenEmptySection) {
        <user-view-regimen-empty [regimen]="regimen" [regimens]="regimens"></user-view-regimen-empty>
      }
      @if (shouldShowRegimenInstruction) {
        <regimen-instruction class="tw-w-full"
                             [regimen]="regimen"
                             [supportTicketId]="supportTicketId"
                             [experiments]="experiments"
                             [regimenContentElement]="regimenModuleContainer"
                             [newInstructionUIExperiment]="newInstructionUIExperiment"
                             [dietBannerV2]="dietBannerV2"
                             [scrollingDown]="scrollingDown"
                             (morningNightTabsVisibilityChange)="isMorningNightTabsVisibilityChange($event)"
                             (reminderToggleChange)="toggleReminders($event)"
                             [reminderToggle]="reminderToggle">
        </regimen-instruction>
      }
      @if (shouldShowRegimenUnpaid) {
        <user-view-regimen-unpaid class="tw-w-full tw-pb-[94px]"
                                  [experiments]="experiments"
                                  [regimen]="regimen"
                                  [fromPreparation]="redirectAfterRegimenPreparation"
                                  [isKeyboardVisible]="isKeyboardVisible"
                                  [isRegimenNewPropositionUI]="isRegimenNewPropositionUI"
                                  [unpaidUserDoctorCalls]="unpaidUserDoctorCalls"
                                  [scrollContainer]="regimenModuleContainer"
                                  (showSummaryView)="showSummaryView($event)"
                                  (buyNow)="buyRegimen()"
                                  (cartChange)="updatePrice($event)"
                                  (updateRegimen)="updateRegimen($event)"
                                  (parentLoading)="parentLoading($event)"
                                  (selectedPlanEmit)="selectedPlan($event)"
                                  (doctorCallCreated)="fetchUnpaidUserDoctorCalls()"></user-view-regimen-unpaid>
      }
      @if (shouldShowRegimenConsultationView) {
        <user-view-regimen-consultation class="w100"
                                        [regimen]="regimen"
                                        [socialProof]="socialProof"
                                        [experiments]="experiments"></user-view-regimen-consultation>
      }
      @if (shouldShowRegimenPreparationUI) {
        <user-view-regimen-preparation class="tw-w-full"
                                       [regimen]="regimen"
                                       [experiments]="experiments"
                                       [renderReport]="showSkinReport"
                                       (showRegimen)="resetFlagAndShowRegimen()"
                                       (hideToolBars)="redirectAfterRegimenPreparation = true"></user-view-regimen-preparation>
      }
      <chatV2-view *ngIf="shouldShowConsultationPage"
                   [hideNavBar]="true"
                   [chatScrollErrorY]="headerHeight"
                   (chatScrollPossible)="autoScrollToBottom()"
                   title="Consultation"
                   [chatUniqueObject]="consultationSession"
                   [where]="{ user, consultationSession }"
                   (chatLoadingStatus)="handleLoadingStatus($event)"
                   (botReplyInProcessChange)="botReplyInProcessChange($event)"
                   dataFunctionName="findConsultationSessionChat"></chatV2-view>
    </div>
    <!--    reminder toggle container-->
    <div *ngIf="!loading && regimen && showReminderContainer && regimen.showProductSummary && newInstructionUIExperiment && (regimen.class === 'FACE') && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED) && !consultationSession && !showRegimenExpiryBanner && !shouldShowAddOnInstructionUI()"
         class="">
      <div *ngIf="!reminderEventSent && !isMorningNightTabsVisible"
           class="tw-flex tw-items-center tw-justify-between tw-w-full tw-min-h-12 tw-bg-teal-300 tw-p-2 tw-px-4">
        <h2 class="tw-font-body tw-flex-1 tw-text-200"
            i18n="@@getRemindersInstruction"><span class="tw-font-bold">Get reminders</span> for product application
        </h2>
        <div class="tw-flex tw-items-center tw-justify-end tw-gap-2">
          <!-- Toggle Switch -->
          <div class="tw-relative tw-inline-block tw-w-10 tw-select-none tw-mb-[-7px]">
            <input type="checkbox"
                   name="toggle"
                   id="reminderToggle"
                   class="tw-sr-only"
                   [checked]="reminderToggle"
                   (change)="onReminderToggleChange($event)">
            <label for="reminderToggle"
                   class="tw-block tw-overflow-hidden tw-h-6 tw-rounded-full tw-cursor-pointer tw-p-0.5 before:tw-content-[''] before:tw-absolute before:tw-h-5 before:tw-w-5 before:tw-rounded-full before:tw-left-0.5 before:tw-top-0.5 before:tw-transition-transform"
                   [ngClass]="{
                   'before:tw-translate-x-4 before:tw-bg-teal-600 tw-bg-white': reminderToggle,
                   'before:tw-translate-x-0 before:tw-bg-white tw-bg-gray-400': !reminderToggle
                 }">
            </label>
          </div>
          <!-- Close Button -->
          <div (click)="closeReminder()"
               class="tw-relative -tw-right-[1px]">
            <img alt="close"
                 src="/assets/icons/reminderClose.svg"
                 class="tw-w-6 tw-h-6" />
          </div>
        </div>
      </div>
      <div *ngIf="reminderEventSent"
           class="tw-flex tw-items-center tw-min-h-12 tw-bg-teal-300 tw-p-2 tw-px-">
        <img class="tw-h-6 tw-w-6"
             src="/assets/gifs/instruction-reminder.gif"
             alt="loader" />
        <h2 class="tw-font-body tw-flex-1 tw-text-200 tw-w-full"
            i18n="@@weWillRemindYou">We will remind you via app notifications</h2>
      </div>
    </div>

    @if (!loading && regimen && regimen.showProductSummary
    && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED) && !consultationSession
    && regimenExpiryExperiment && showRegimenExpiryBanner) {
    <regimen-expiry-strip [userFirstName]="userFirstName"
                          [regimenExpiryBannerData]="regimenExpiryBannerData"
                          [page]="'regimen'"
                          (bannerClick)="handleRegimenExpiryBannerClick()"></regimen-expiry-strip>
    }

    <div class="tw-flex-none tw-bg-white tw-py-5  tw-z-[11]"
         *ngIf="(!loading && regimen && regimen.showPriceDetail && regimen.totalSP && !regimen.regimenPreparation && !regimen.active && !regimen.orderPlaced && !isKeyboardVisible && !shouldShowAddOnInstructionUI()) || (regimen.showConsultationView && !regimen.orderPlaced && !isKeyboardVisible && !shouldShowAddOnInstructionUI())">
      @if (acqRebranding2025) {
      <button class="tw-border-none tw-w-full tw-h-[54px] tw-relative tw-text-[#ffffff] tw-text-[18px] tw-capitalize tw-p-4 shine loop tw-bg-teal-600 tw-overflow-visible tw-mb-2 tw-rounded-3"
              (click)="buyRegimen()">
        <div
             class="tw-absolute tw-flex tw-items-center tw-justify-center tw-top-[-15px] tw-left-[10px] tw-text-orange-400">
          <svg class="tw-w-[85px] tw-h-[85px] tw-relative tw-animate-spin_slow"
               xmlns="http://www.w3.org/2000/svg"
               width="64.443"
               height="67.447"
               viewBox="0 0 64.443 67.447">
            <path id="Path_23051"
                  data-name="Path 23051"
                  d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                  transform="translate(-23.961 -186.363)"
                  fill="#D66736"></path>
          </svg>
          <span
                class="tw-absolute tw-font-body tw-text-650 tw-text-white tw-z-20 tw-font-bold tw-leading-none">{{regimen.discount}}%
            <br />Off </span>
        </div>
        <span class="tw-ml-20 tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]">
          <span [ngStyle]="{ 'font-size': user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'ml' ? '12px' : '18px' }"
                i18n="@@buyNow">Buy Now</span>
          <span> &#64;</span>
          <span class="tw-text-200  tw-line-through">₹{{regimen.totalMRP}}</span>
          <span>₹{{regimen.totalSP}}</span>
        </span>
      </button>
      } @else {
      <button class="tw-bg-[#00AB5E] tw-border-none tw-p-6 tw-w-full tw-h-14 tw-relative tw-text-white tw-capitalize tw-overflow-visible tw-text-500 shine"
              id="buyNowButton"
              (click)="buyRegimen()"
              [disabled]="isInternalUser">
        <div class="tw-absolute tw-flex tw-items-center tw-justify-center tw-left-[10px] tw-top-[-15px]">
          <svg class="tw-h-[85px] tw-w-[85px] tw-relative tw-animate-spin_slow"
               xmlns="http://www.w3.org/2000/svg"
               width="64.443"
               height="67.447"
               viewBox="0 0 64.443 67.447"
               [ngStyle]="{'fill': discountSpinnerFillColor}">
            <path id="Path_23051"
                  data-name="Path 23051"
                  d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                  transform="translate(-23.961 -186.363)"></path>
          </svg>
          <span
                class="tw-absolute tw-text-650 tw-text-white tw-uppercase tw-z-20 tw-font-bold tw-leading-none">{{regimen.discount}}%
            <br />off </span>
        </div>
        <span class="tw-ml-20">
          <span [ngStyle]="{ 'font-size': user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'ml' ? '12px' : '18px' }"
                i18n="@@buyNow">Buy Now</span>
          <span> &#64;</span>
          <span class="tw-text-300 tw-line-through">₹{{regimen.totalMRP}}</span>
          <span>₹{{regimen.totalSP}}</span>
        </span>
      </button>
      }
    </div>

    <div class="tw-flex-none"
         [ngClass]="{'shadow': !(!loading && regimen && showReminderContainer && regimen.showProductSummary && newInstructionUIExperiment)}"
         *ngIf="shouldShowRegimenFooter">
      <div class="tw-w-full"
           *ngIf="offerTimer.endTime > 0 && (!regimen.active && !regimen.orderPlaced)">
        <discount-timer [endTime]="offerTimer.endTime"
                        [text]="offerTimer.title"></discount-timer>
      </div>
      <div class="tw-w-full tw-p-4"
           *ngIf="!regimen.objectId && !consultationSession && !regimen.regimenPreparation && !newInstructionUIExperiment">
        <cs-button [class]="'w100 primary'"
                   [disabled]="isInternalUser"
                   (callback)="triggerTreeForRegimen()">
          @if (isRegimenExpiredForPaidUser) {
            <cs-button-text class="tw-font-body" i18n="@@restartTreatment">Restart Treatment</cs-button-text>
          } @else {
            <cs-button-text class="tw-font-body"
                            i18n="@@getYourTreatment">Get your treatment kit</cs-button-text>
          }
        </cs-button>
      </div>
      <div class="tw-w-full tw-p-4"
           *ngIf="!regimen.objectId && !consultationSession && !regimen.regimenPreparation && newInstructionUIExperiment">
        <cs-button class="tw-bg-teal-600 tw-rounded-full"
                   [class]="'w100 primary'"
                   [disabled]="isInternalUser"
                   (callback)="triggerTreeForRegimen()">
          @if (isRegimenExpiredForPaidUser) {
            <cs-button-text class="tw-font-body" i18n="@@restartTreatment">Restart Treatment</cs-button-text>
          } @else {
            <cs-button-text class="tw-font-body"
                            i18n="@@getYourTreatment">Get your treatment kit</cs-button-text>
          }
        </cs-button>
      </div>
      @if (!regimen.active && regimen.orderPlaced && newInstructionUIExperiment && !isKeyboardVisible) {
      <div class="tw-w-full tw-py-6 tw-px-4">
        <button class="tw-w-full tw-p-4 tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px] tw-rounded-3"
                [disabled]="isInternalUser"
                (click)="openRegimenOrderStatus()">
          <span i18n="@@checkOrderDetails">Check Order Details</span>
        </button>
      </div>
      }
      @if (!regimen.active && regimen.orderPlaced && !newInstructionUIExperiment && !isKeyboardVisible) {
      <div class="tw-w-full tw-p-4">
        <cs-button [class]="'w100 secondary'"
                   [disabled]="isInternalUser"
                   (callback)="openRegimenOrderStatus()">
          <cs-button-text i18n="@@checkOrderDetails">Check Order Details</cs-button-text>
        </cs-button>
      </div>
      }

      <!--      Old instruction page cta container -->
      <div class="tw-w-full tw-p-4 tw-flex tw-justify-around tw-gap-3"
           *ngIf="regimen.active && regimen.showProductSummary && !newInstructionUIExperiment">
        <div class="tw-flex-1">
          <cs-button class="tw-border tw-rounded-full tw-border-black tw-text-green-400"
                     [class]="'w100 purple btn-xs'"
                     (callback)="showPriceDetails()">
            <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
          </cs-button>
        </div>
        <div class="tw-flex-1">
          <cs-button class="tw-border tw-rounded-full tw-border-green-400"
                     [class]="'w100 primary btn-xs'"
                     [disabled]="isInternalUser"
                     (callback)="reorder()">
            <cs-button-text i18n="@@reorder">Reorder</cs-button-text>
          </cs-button>
        </div>
      </div>
      <!--      New instruction page cta container -->
      <ng-container *ngIf="regimen.active && regimen.showProductSummary && newInstructionUIExperiment">
        <ng-container *ngTemplateOutlet="readDetailedInstructionsButton"></ng-container>
      </ng-container>
      <div class="tw-w-full tw-p-4"
           *ngIf="regimen.active && regimen.showPriceDetail && !newInstructionUIExperiment">
        <cs-button [class]="'w100 secondary'"
                   [disabled]="isInternalUser"
                   (callback)="showSummaryView(true)">
          <cs-button-text i18n="@@readInstructions">Read Instructions</cs-button-text>
        </cs-button>
      </div>
      <div class="tw-w-full tw-h-18 tw-p-4"
           *ngIf="regimen.active && regimen.showPriceDetail && newInstructionUIExperiment">
        <button [disabled]="isInternalUser"
                class="tw-bg-teal-600 tw-w-full tw-py-2 tw-px-6 tw-text-white tw-text-center tw-rounded-3 tw-font-body tw-font-bold tw-h-[40px]"
                (click)="showSummaryView(true)"
                i18n="@@readInstructions">Read Instructions</button>
      </div>
      <div class="tw-w-full tw-p-4 tw-flex tw-justify-around tw-gap-3"
           *ngIf="!regimen.active && regimen.showProductSummary && !regimen.orderPlaced && !newInstructionUIExperiment && !isKeyboardVisible">
        <div class="tw-flex-1">
          <cs-button class="tw-border tw-rounded-full tw-border-black tw-text-green-400"
                     [class]="'w100 purple btn-xs'"
                     [disabled]="isInternalUser"
                     (callback)="readMoreAboutProducts()">
            <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
          </cs-button>
        </div>
        <div class="tw-flex-1">
          <cs-button id="buyNowButton"
                     [class]="isTabActive ? 'w100 primary shine btn-xs' : 'w100 primary btn-xs'"
                     [disabled]="isInternalUser"
                     (callback)="buyRegimen()">
            <cs-button-text i18n="@@buyNow">Buy Now</cs-button-text>
          </cs-button>
        </div>
      </div>

      <div class="tw-w-full tw-p-4 tw-flex tw-justify-around tw-gap-3"
           *ngIf="!regimen.active && regimen.showProductSummary && !regimen.orderPlaced && !isKeyboardVisible && newInstructionUIExperiment">
        <div class="tw-flex-1">
          <cs-button class="tw-border tw-rounded-full tw-border-teal-600 tw-text-teal-600"
                     [class]="'w100 purple btn-xs'"
                     [disabled]="isInternalUser"
                     (callback)="readMoreAboutProducts()">
            <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
          </cs-button>
        </div>
        <div class="tw-flex-1">
          <cs-button id="buyNowButton"
                     class="tw-bg-teal-600 tw-rounded-full"
                     [class]="isTabActive ? 'w100 primary shine btn-xs' : 'w100 primary btn-xs'"
                     [disabled]="isInternalUser"
                     (callback)="buyRegimen()">
            <cs-button-text i18n="@@buyNow">Buy Now</cs-button-text>
          </cs-button>
        </div>
      </div>
    </div>

    @if (shouldShowAddOnInstructionUI() && !loading) {
    <ng-container *ngTemplateOutlet="readDetailedInstructionsButton"></ng-container>
    }
  </div>
</div>
<ng-template #languageDropdown>
  <div class="tw-flex tw-justify-center tw-items-center tw-gap-1 tw-shrink-0 tw-h-6 tw-px-2 tw-bg-transparent tw-border tw-border-solid tw-border-teal-100 tw-rounded-6"
       (click)="openLanguageChangeDrawer()">
    <span
          class="tw-font-body tw-text-100 tw-font-bold tw-text-gray-50">{{appConfig.Shared.LanguagesLong[user.get('languagePreference')?.toUpperCase()
      || appConfig.Shared.Languages.EN.toUpperCase()]}}</span>
    <svg xmlns="http://www.w3.org/2000/svg"
         width="9"
         height="9"
         viewBox="0 0 9 9"
         fill="none">
      <mask id="mask0_24481_23258"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="9"
            height="9">
        <rect x="8.5"
              y="0.0175781"
              width="8"
              height="8"
              transform="rotate(90 8.5 0.0175781)"
              fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_24481_23258)">
        <path d="M1.16634 2.69274L1.75801 2.10107L4.49967 4.84274L7.24134 2.10107L7.83301 2.69274L4.49967 6.02607L1.16634 2.69274Z"
              fill="white" />
      </g>
    </svg>
  </div>
</ng-template>

<ng-template #readDetailedInstructionsButton>
  <div class="tw-w-full tw-h-18 tw-p-4">
    <button class="tw-bg-teal-600 tw-w-full tw-py-2 tw-px-6 tw-text-white tw-text-center tw-rounded-3 tw-font-body tw-font-bold tw-h-[40px]"
            (click)="showPriceDetails()"
            i18n="@@readDetailedInstructions">Read Detailed Instructions</button>
  </div>
</ng-template>
